import Vue from 'vue'

const client = Vue.prototype.$api

export default {
    getCodeDiscount (data) {
        return client.get('PromotionCodes/GetCodeDiscount', { params: data })
    },
    applyDiscount (data) {
        return client.post('PromotionCodes/ApplyDiscount', data)
    }
}


// WEBPACK FOOTER //
// ./src/repositories/PromotionCodesRepository.js